<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}
      </v-alert>

      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Zmień nazwę
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div>
          <div class="scrollable-height">
            <div class="pt-4">
              <div class="px-4">
                <div class="body-2 grey--text">
                  Wpisz nową nazwę dla elementu
                </div>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="name"
                  :error-messages="errors.collect('dir_name')"
                  v-validate="'min:1|max:250|required'"
                  data-vv-name="dir_name"
                  data-vv-as="nazwa"
                  required
                ></v-text-field>
              </div>
            </div>
          </div>
          <v-card-actions class="px-4 py-4">
            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="rename"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';

export default {
  name: 'rename-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    name: null,
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'rename';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'renameItem',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    rename() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.setNewName();
        }
      });
    },
    async setNewName() {
      this.busy = true;
      try {
        await this.renameItem({ name: this.name });
        this.busy = false;
        this.setDialogVisbility(false);
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (oldVal) {
        this.clearData();
      }
    },
    dialogVisibility(val) {
      if (!val) {
        this.directoryName = null;
      } else {
        this.name = this.dialogVisibility.name;
      }
    },
  },
};
</script>
